import request from '@/utils/request'

// 查询通用类型列表数据
export function findCommonTypes(params) {
  return request({
    url: `/common_types`,
    method: 'get',
    params: params
  })
}

// 查询单个通用类型表单值
export function findCommonTypeForm(id) {
  return request({
    url: `/common_types/${id}/form`,
    method: 'get'
  })
}

// 更新通用类型数据
export function updateCommonType(id, data) {
  return request({
    url: `/common_types/${id}`,
    method: 'put',
    data
  })
}

// 创建通用类型数据
export function createCommonType(data) {
  return request({
    url: `/common_types`,
    method: 'post',
    data
  })
}

// 更新通用有效性
export function batchUpdateCommonTypesEffective(ids, effective) {
  const data = { ids: ids, effective: effective }
  return request({
    url: `/common_types/effective/batch`,
    method: 'patch',
    data
  })
}

// 通用类型类型选项数据
export function findCommonTypeTypeOptions() {
  return request({
    url: `/common_types/type_options`,
    method: 'get'
  })
}

// 通用类型选项数据
export function findCommonTypeOptions(typeSlug) {
  return request({
    url: `/common_types/options`,
    method: 'get',
    params: { type_slug: typeSlug }
  })
}

// 通用类型子类型Slug选项数据
export function findCommonTypeSubTypeSlugOptions(typeSlug) {
  return request({
    url: `/common_types/sub_type_slug_options`,
    method: 'get',
    params: { type_slug: typeSlug }
  })
}
